module.exports = __webpack_public_path__ + "img/logo_b7web.9a55e028.png";